export enum PaymentMethod {
  STRIPE = 'stripe',
}
